import {Ability} from '@casl/ability'

export const ability = new Ability()

export const abilityPlugin = (store) => {
	ability.update(store.state.rules);
	return store.subscribe((mutation) => {
		switch (mutation.type) {
			case 'loginSuccess':
				let formattedRules = [];
				if (mutation.payload.permissions.length > 0) {
					formattedRules = mutation.payload.permissions.map(perm => {
						let indexSpace = perm.indexOf(' ');
						let formattedObj = {};
						formattedObj.actions = perm.substr(0, indexSpace);
						formattedObj.subject = perm.substr(indexSpace + 1);
						return formattedObj;
					})
				}
				ability.update(formattedRules);
				break
			case 'logoutSuccess':
				ability.update([{actions: 'read', subject: 'all'}])
				break
		}
	})
}
